<template>
    <div id="top_menu_partitions" class="ui item dropdown" v-dropdown>
        <div v-if="customer_partitions.length > 1">
            您有{{ customer_partitions.length }}組 區間號碼
            <i class="dropdown icon"></i>
        </div>

        <div v-else-if="customer_partitions.length == 1" class="only_one partition">
            您的號碼區間為
            <Partition
                v-for="partition in customer_partitions"
                :partition="partition"
                :key="partition.identity"
            >
            </Partition>

        </div>

        <div v-else>
            您尚未被受理任何 號碼區間
        </div>

        <div class="menu" v-if="customer_partitions.length > 1">
            <Partition
                v-for="partition in customer_partitions"
                :partition="partition"
                :key="partition.identity"
            >
            </Partition>

        </div>
    </div>

</template>

<script>
    import Partition from './top_menu_partition.vue'

    export default {
        mounted() {
        },
        computed: {
            customer_partitions() {
                return this.$store.state.customer.customer_partitions
            },
        },
        methods: {
            integer_rjust(integer, width, padding) {
                return integer.toString().rjust(width, padding)
            }
        },
        components: {
            Partition,
        },
    }
</script>

<style scoped lang="scss">
    @media only screen and (max-width: 767px) {
        .only_one.partition {
            margin-top: 6px;
        }
    }
</style>
